import getInstance from "../config/api";

export default class ReceivablesAnticipation {
  static async importCsvReceivablesAnticipation(body) {
    const instance = getInstance();
    const { data } = await instance.post(
      `/contract/receivables-anticipation`,
      body
    );
    return data;
  }

  static async fetchReceivablesAnticipation(params) {
    const instance = getInstance();
    const { data } = await instance.get(
      "/contract/get-receivables-anticipation",
      { params }
    );
    return data;
  }
}
